// extracted by mini-css-extract-plugin
export default {"links-container":"Links_links-container__yFhvC","navLink":"Links_navLink__hrq9P","link-element":"Links_link-element__Vuny-","mobile-links":"Links_mobile-links__J2cPA"};